import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取子系统下拉列表
  getSysUserList() {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysApp/list`);
  },
  // 获取用户列表
  getUserList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysUser/page`, { params });
  },
  // 修改用户状态
  postUserStatus(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/changeStatus`, params);
  },
  // 添加子系统超管
  postNewUser(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/add`, params);
  },
  // 修改子系统超管信息
  postEditUser(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/edit`, params);
  },
  // 分配权限
  postGrantApp(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/grantApp`, params);
  }
};
